
import { Button, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';


const ButtonComponent = ({ onClick, children, variant = 'primary', extraClass, loading, ...props}) => {
  const buttonVariant = variant === 'primary' ? 'button-primary' : 'button-secondary';
  return (
    <Button
      onClick={onClick}
      className={ `${buttonVariant} ${extraClass} btn-common mt-2 openSans b-0`}
      variant={variant}
      {...props}>
      {loading ? <Spinner animation="border" size="sm" /> : children}
    </Button>
  )
}

ButtonComponent.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary']),
  extraClass: PropTypes.string,
  loading: PropTypes.bool
};

export default ButtonComponent

